<template>
    <div>
        <footer>
            <div class="footer__area-three">
                <div class="footer__top-three">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-5 col-md-8">
                                <div class="footer-widget">
                                    <div class="footer__newsletter-three">
                                        <h2 class="title">
                                            Jangan Pernah Kehilangan Momen Apa pun
                                        </h2>
                                    </div>
                                    <div class="footer__social-three">
                                        <span class="title">Ikuti Kami:</span>
                                        <ul class="list-wrap">
                                            <li>
                                                <a href="https://www.facebook.com/profile.php?id=100093039472433" target="_blank"><i class="fab fa-facebook-f"></i></a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/rskonselblud/" target="_blank"><i class="fab fa-instagram"></i></a>
                                            </li>
                                            <!-- <li>
                                                <a href="javascript:void(0)"><i class="fab fa-pinterest-p"></i></a>
                                            </li> -->
                                            <!-- <li>
                                                <a href="javascript:void(0)"><i class="fab fa-youtube"></i></a>
                                            </li> -->
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Informasi</h4>
                                    <div class="footer-link-list">
                                        <ul class="list-wrap">
                                            <li><router-link to="/berita" target="_blank">Berita</router-link></li>
                                            <li><router-link to="/tentangKami" target="_blank">Tentang Kami</router-link></li>
                                            <li><router-link to="/dokterRSUD" target="_blank">Dokter RSUD</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Location</h4>
                                    <div class="footer-info-list">
                                        <ul class="list-wrap">
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-phone-call"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="tel:0123456789">+62 822-9662-2291</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-envelope"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="mailto:info@apexa.com">rsd@konaweselatankab.go.id</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-pin"></i>
                                                </div>
                                                <div class="content">
                                                    <p>Jl. Poros Andoolo No. 1, Kompleks Perkantoran Pemda, Kelurahan Potoro, Kecamatan Andoolo, Kabupaten Konawe Selatan, Sulawesi Tenggara 93811.</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer__bottom-three">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-6">
                                <div class="copyright-text">
                                    <p>Copyright © <a href="index.html">Apexa</a> | All Right Reserved</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    data() {
        return {

            id: "",
            list_foto: [],
            unit_kerja: this.$store.state.UNIT_KERJA,

            file_path: this.$store.state.url.URL_APP + "uploads/",
            galeryku: {
                id: '',
                judul: '',
                deskripsi: '',
                file: '',
                unit_kerja: '',
                status: '',
                createBy: '',
                createAt: '',
            },
        }
    },


    methods: {
        getFoto: function () {
            fetch(this.$store.state.url.URL_FOTO, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                },
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_foto = res_data
                    // console.log(res_data);
                });
        },

        selectDataFoto: function (data) {
            this.galeryku = {
                id: data.id,
                judul: data.judul,
                deskripsi: data.deskripsi,
                file: data.file,
                unit_kerja: data.unit_kerja,
                status: data.status,
                createBy: data.createBy,
                createAt: data.createAt,
            };
            // console.log(data);
        },
    },


    mounted() {
        this.getFoto();
    },
}
</script>

<style></style>